import { z } from 'zod';
/**
 * Guarded withdraw of a suggestion the submitter no longer wants — fired when a
 * reassign flow that eagerly created the suggestion is cancelled.
 *
 * No request body. The backend deletes the suggestion only when it is still
 * `pending` AND no `{ type: 'suggestion', id }` slot references it anywhere
 * (another user may have adopted it from a picker in the meantime). Every other
 * case — already resolved, still referenced, or already gone — is a successful
 * no-op (`withdrawn: false`), so racing cancels and retries never surface
 * errors.
 */ export const WithdrawEntitySuggestionResponseSchema = z.object({
    data: z.object({
        withdrawn: z.boolean()
    })
});

//# sourceMappingURL=withdraw-entity-suggestion.contract.js.map